var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCloudRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.44 18.14-2.11-2.11a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.11 2.11c.29.29.29.77 0 1.06-.14.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3 18.17a.754.754 0 0 1 0-1.06L12.41 15c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-2.11 2.11a.75.75 0 0 1-1.06 0zM5.54 19.34c-2.94-.21-4.26-2.47-4.26-4.49s1.32-4.28 4.21-4.48c.4-.04.77.28.8.7.03.42-.28.77-.7.8-1.94.14-2.81 1.6-2.81 2.99 0 1.39.87 2.85 2.81 2.99h1.87c.41 0 .75.34.75.75s-.34.74-.75.74H5.54z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.62 19.34c-.41 0-.79-.34-.79-.75 0-.43.33-.75.74-.75 1.24 0 2.33-.43 3.19-1.2 1.56-1.36 1.66-3.32 1.24-4.7-.42-1.37-1.59-2.94-3.63-3.19a.753.753 0 0 1-.65-.62c-.4-2.4-1.69-4.06-3.65-4.66-2.03-.63-4.38-.01-5.85 1.53-1.43 1.49-1.76 3.58-.93 5.88a.75.75 0 1 1-1.41.51c-1.01-2.82-.55-5.52 1.26-7.42 1.85-1.94 4.82-2.71 7.37-1.93 2.34.72 3.99 2.65 4.59 5.33 2.05.46 3.68 2.01 4.33 4.15.71 2.33.07 4.73-1.67 6.25-1.12 1-2.57 1.57-4.09 1.57h-.05z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08 19.48c-.11-.17-.22-.38-.31-.59-.34-.71-.52-1.51-.52-2.36 0-3.17 2.58-5.75 5.75-5.75s5.75 2.58 5.75 5.75c0 .85-.18 1.65-.53 2.39-.08.19-.19.39-.31.58A5.741 5.741 0 0 1 12 22.28c-2.01 0-3.89-1.07-4.92-2.8zm.67-2.95c0 .62.13 1.21.38 1.73.08.17.15.31.23.44a4.227 4.227 0 0 0 3.63 2.08c1.48 0 2.87-.79 3.62-2.06.09-.15.16-.28.23-.43.27-.55.4-1.13.4-1.76.01-2.34-1.9-4.25-4.24-4.25a4.26 4.26 0 0 0-4.25 4.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCloudRemove);
export default __webpack_public_path__ + "static/media/vuesax-outline-cloud-remove.90ef003d9ccb9a7fd88b2df797ff123d.svg";
export { ForwardRef as ReactComponent };